import { JwtAxios } from '@/packaging';

export const marketProductApi = {
  async getDefaultPageData() {
    const res = await JwtAxios.get(`/MarketProduct/GetDefaultPageData`);
    return res;
  },
  async searchUploadProduct(body) {
    const res = await JwtAxios.post(`/MarketProduct/SearchUploadProduct`, body);
    return res;
  },
  async GetDeleteMarketList(body) {
    const res = await JwtAxios.post(`/MarketProduct/GetDeleteMarketList`, body);
    return res;
  },
  async GetDeleteList(body) {
    const res = await JwtAxios.post(`/MarketProduct/GetDeleteList`, body);
    return res;
  },
  async SetStatusChange(id, body) {
    const res = await JwtAxios.put(`/MarketProduct/SetStatusChange?connectionId=${id}`, body);
    return res;
  },
  async SetUpdateOption(body) {
    const res = await JwtAxios.patch('/MarketProduct/SetUpdateOption', body);
    return res;
  },
  async DeleteMarketProduct(body){
    const res = await JwtAxios.post('/MarketProduct/DeleteMarketProduct', body);
    return res;
  },
  async DeleteMarketProductByPeriod(body){
    const res = await JwtAxios.post('/MarketProduct/DeleteMarketProductByPeriod', body);
    return res;
  },
  async GetCoupangProductUrl({ productId, productCode, marketAccount, marketIdx }) {
    const query = new URLSearchParams({productId,productCode, marketAccount,marketIdx}).toString();
    const res = await JwtAxios.get(`/MarketProduct/GetCoupangProductUrl?${query}`);
    return res;
  },
  async SetSafeLock(body) {
    const response = await JwtAxios.patch('/MarketProduct/SetSafeLock', body);
    return response;
  },
  async GetUpdateStatus(productId) {
    const res = await JwtAxios.get(`/MarketProduct/GetUpdateStatus?productId=${productId}`);
    return res;
  },
  async DoUpdate(connectionId, body) {
    const res = await JwtAxios.post(`/Market/DoUpdate?id=${connectionId}`, body);
    return res;
  },
};
